import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IdleTimerService } from 'src/app/services/idle-timer.service';

@Component({
  standalone: false,
  selector: 'ngbd-modal-content',
  template: `
    <div class="modal-header">
      <div id="dialog-child-name" class="modal-title modal-title-timeout pull-left">Session Timeout Warning!</div>
      <button type="button" class="close btn pull-right" aria-label="Close" (click)="activeModal.close('close')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
    <p>
       {{idleState}}<br>
       {{countDownText}}<br>
    </p>
      <div class="row mrgbtm">
        <div class="col-6">
            <button type="button" (click)="activeModal.close('logout')" class="btn btn-danger">Logout</button>
        </div>
        <div class="col-6">
            <button type="button" (click)="activeModal.close('stay')" class="btn btn-success stay-btn">Stay</button>
        </div>
      </div>
  </div>
  `
})
export class TimeoutModalComponent implements OnInit {
  @Input() idleState;
  countDownText: string;

  constructor(
    public activeModal: NgbActiveModal,
    private idleTimerService: IdleTimerService) {}

  ngOnInit(): void {
    this.subscribeToCountDownTimerText();
  }

  unsubscribe$: Subject<boolean> = new Subject();

  subscribeToCountDownTimerText(): void {
    this.idleTimerService.getCountDownObs().pipe(takeUntil(this.unsubscribe$))
    .subscribe((countDownText) => {
        if (countDownText) {
          this.countDownText = countDownText;
        }
      });
  }

}